<template>
  <div class="mainContainer fadeIn">
    <Header />
    <div class="bodyBox">
      <Sidebar />
      <MainContent />
      <ModalsContainer />
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header';
import Sidebar from '@/components/Sidebar';
import MainContent from './MainContent';
import ModalsContainer from './ModalsContainer';

export default {
  name: 'Dashboard',
  components: { Header, Sidebar, MainContent, ModalsContainer },
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
